import { render, staticRenderFns } from "./group-data.vue?vue&type=template&id=4cb054a2&scoped=true&"
import script from "./group-data.vue?vue&type=script&lang=js&"
export * from "./group-data.vue?vue&type=script&lang=js&"
import style0 from "./group-data.vue?vue&type=style&index=0&id=4cb054a2&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb054a2",
  null
  
)

export default component.exports